import { type BoxProps } from '@pets-ui/Box/Box'
import { Box } from '@pets-ui/Box/Box'
import { CircularProgress } from '@pets-ui/CircularProgress/CircularProgress'
import { colors } from '@pets-ui/tokens/colors.stylex'

export const LoaderFullPage = (props: BoxProps) => {
  return (
    <Box
      zIndex={1}
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="fixed"
      top={0}
      right={0}
      left={0}
      bottom={0}
      backgroundColor={colors.white}
      {...props}
    >
      <CircularProgress fontSize={36} />
    </Box>
  )
}
